import React from 'react'
import { Link } from 'react-router-dom';
import paths from '../../routes/paths';

export default function AboutPage() {
    return (
        <div className="text-center text-lg text-primary">
            About Page <br />
            <Link to={paths.home} className="text-secondary underline"> Go Home Page </Link>
        </div>
    )
}
